// Smoothscroll also with page change reload, jumps to top and scrolls down again

// switch off in development, when browser sync is on
if (document.getElementById('__bs_script__') === null) {
  // to top right away
  if (window.location.hash) window.scroll(0, 0);
  // void some browsers issue
  setTimeout(() => {
    window.scroll(0, 0);
  }, 50);

  window.addEventListener('load', () => {
    setTimeout(() => {
      if (window.location.hash) {
        // smooth scroll to the anchor id
        $('html, body').animate({
          scrollTop: `${$(window.location.hash).offset().top}px`,
        }, 500);
      }
    }, 50);
  });
}

// smoothscroll for links with hash
$(() => {
  // @fixme avoid to kill standard bs4 functionality like collapse elements
  // eslint-disable-next-line func-names
  $('a:not([aria-controls])').on('click', function () {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== '' && $(this.hash).length > 0 && this.pathname === location.pathname) {
      // Store hash
      const { hash } = this;
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll
      // to the specified area

      if ($(this.hash).parents('details:not([open])').length > 0) {
        $(this.hash).parents('details:not([open])').attr('open', 'open');
      }

      $('html, body').animate({
        scrollTop: $(hash).offset().top,
      }, 500, () => {
        // Add hash (#) to URL when done scrolling (default click behavior)
        if (window.history.pushState) {
          // IE10, Firefox, Chrome, etc.
          window.history.pushState(null, null, hash);
        } else {
          window.location.hash = hash;
        }
      });
      return false;
    } // End if
    return true;
  });
});
